import Scene from "~/scene";

export default class DrawCanvas {
	_canvas: HTMLCanvasElement;

	_ctx: CanvasRenderingContext2D;

	_parent: HTMLDivElement;

	constructor() {
		this._canvas = document.createElement("canvas");
		this._ctx = this._canvas.getContext("2d");
		this._parent = document.getElementById("map") as HTMLDivElement;
		this._canvas.style.position = "absolute";
		this._canvas.style.inset = "0 0 0 0";
		this._canvas.style.zIndex = "100";
	}

	/* eslint-disable-next-line */
	setStyle() {}

	getContext(cb: (ctx: CanvasRenderingContext2D) => void) {
		cb(this._ctx);
	}

	clear() {
		this._ctx.clearRect(0, 0, this._ctx.canvas.width, this._ctx.canvas.height);
	}

	enable() {
		const size = Scene.getSize();

		this._parent.append(this._canvas);
		this._canvas.width = size.x;
		this._canvas.height = size.y;
		this._canvas.style.width = `${size.x}px`;
		this._canvas.style.height = `${size.y}px`;
	}

	disable() {
		this._canvas.remove();
	}
}
